import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    accountid: String
  }


  connect() {
    this.provider = this.element.querySelector("#provider")
    this.provider.addEventListener("change", this.change.bind(this))

    this.syncCSRFToken()
    this.updateForm()
  }

  syncCSRFToken() {
    let csrfToken = document.head.querySelector("meta[name=csrf-token]")?.content
    this.element.querySelector("input[name=authenticity_token]").value = csrfToken
  }

  change() {
    this.updateForm()
  }

  updateForm() {
    if (this.provider.value === "tiktok_api_authorization") {
      this.element.setAttribute("action", `/admin/accounts/${this.accountidValue}/authorizations/redirect`)
      this.element.setAttribute("method", "get")
    } else {
      this.element.setAttribute("action", `/auth/${this.provider.value}?account_id=${this.accountidValue}`)
      this.element.setAttribute("method", "post")
    }
  }

  disconnect() {
    this.provider.removeEventListener("change", this.change.bind(this))
  }
}
